export const toSentenceCase = (str: string): string =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

export const toTitleCase = (str: string): string =>
    str
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
